<template>
  <!--
            作者：luoyiming
            时间：2019-06-04
            描述：插件中心-分销
        -->
  <div>
    <!--入驻申请-->
    <User v-if="activeName == 'user'"></User>
    <Technician v-if="activeName == 'technician'"></Technician>
    <Transfer v-if="activeName == 'transfer'"></Transfer>
  </div>
</template>
<script>
import bus from "@/utils/eventBus.js";
import PlusApi from "@/api/plus.js";
import User from "./user/index";
import Technician from "./technician/index";
import Transfer from "./transfer/index";

export default {
  components: {
    User,
    Technician,
    Transfer
  },
  data() {
    return {
      formInline: {
        nick_name: ""
      },
      /*参数*/
      param: {},
      /*当前选中*/
      activeName: "user",
      /*切换数组*/
      sourceList: [
        {
          key: "user",
          value: "用户提现申请",
          path: "/cash/operate/user/index"
        },
        {
          key: "technician",
          value: "技师提现申请",
          path: "/cash/operate/technician/index"
        },
        {
          key: "transfer",
          value: "发票列表",
          path: "/cash/operate/transfer/index"
        }
      ],
      /*权限筛选后的数据*/
      tabList: [],
      /*判断third是否有参数*/
      is_third_param: false
    };
  },
  watch: {
    //监听路由
    $route(to, from) {
      this.init();
    }
  },
  created() {
    this.init();
  },
  beforeDestroy() {
    //发送类别切换
    bus.$emit("tabData", { active: null, tab_type: "operate", list: [] });
    bus.$off("activeValue");
  },
  methods: {
    /*初始化方法*/
    init() {
      this.tabList = this.authFilter();

      if (this.tabList.length > 0) {
        this.activeName = this.tabList[0].key;
      }

      if (this.$route.query.type != null) {
        this.activeName = this.$route.query.type;
      }

      /*监听传插件的值*/
      bus.$on("activeValue", res => {
        if (this.is_third_param) {
          this.param.user_id = "";
          this.is_third_param = false;
        }
        this.activeName = res;
      });

      //发送类别切换
      let params = {
        active: this.activeName,
        list: this.tabList,
        tab_type: "operate"
      };
      bus.$emit("tabData", params);
    },

    /*权限过滤*/
    authFilter() {
      let list = [];
      for (let i = 0; i < this.sourceList.length; i++) {
        let item = this.sourceList[i];
        if (this.$filter.isAuth(item.path)) {
          list.push(item);
        }
      }
      console.log(list, "999");
      return list;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/cash/operate/index.vue